import { provideWidgetClass } from 'scrivito'

export const TimeTrackingOverviewWidget = provideWidgetClass(
  'TimeTrackingOverviewWidget',
  {
    attributes: {},
  },
)
